module.exports = __webpack_public_path__ + "img/emergency-medical.28ab8836.png";